// extracted by mini-css-extract-plugin
export var anticlockwise = "bt_fz";
export var svg = "bt_fx";
export var wrapper = "bt_C";
export var wrapperFlexCenter = "bt_fy";